import flows from "./../flows";

export function selectFlowSchedule(store, flowId) {
    return flows[flowId] || flows.default;
}